import { createStore } from 'redux';
import middleware from '@store/middleware';
import initialState from '@store/initial-state';
import rootReducer from '@store/root-reducer';

export default createStore(rootReducer, initialState, middleware);